export default function getIdentityKey(obj, arr, identityKey) {

	if (typeof identityKey === 'function')
	{
		return identityKey(obj);
	}
    else if (typeof identityKey === 'string')
    {
        return obj[identityKey];
    }
    else if (obj.id)
    {
        return obj.id;
    }
    else if (obj.guid)
    {
        return obj.guid;
    }
    else
    {
        return arr.findIndex(o => o === obj);
    }
}


// WEBPACK FOOTER //
// ./app/b3/utils/getIdentityKey.js